export const isWithdrawEnabled = (withdrawStatus) => {
  if (typeof withdrawStatus === "boolean") return withdrawStatus;
  if (typeof withdrawStatus === "number") return withdrawStatus === 1;
  if (typeof withdrawStatus === "string") {
    const normalized = withdrawStatus.trim().toLowerCase();
    return ["true", "1", "active", "open"].includes(normalized);
  }
  return false;
};

export const parseWithdrawalTime = (timeString) => {
  if (!timeString || typeof timeString !== "string") return null;

  const [time, meridian = ""] = timeString.trim().split(/\s+/);
  const [rawHours, rawMinutes = "0"] = time.split(":");
  let hours = Number(rawHours);
  const minutes = Number(rawMinutes);
  const normalizedMeridian = meridian.toLowerCase();

  if (Number.isNaN(hours) || Number.isNaN(minutes) || minutes < 0 || minutes > 59) return null;
  if (normalizedMeridian && !["am", "pm"].includes(normalizedMeridian)) return null;
  if (normalizedMeridian && (hours < 1 || hours > 12)) return null;
  if (!normalizedMeridian && (hours < 0 || hours > 23)) return null;

  if (normalizedMeridian === "pm" && hours < 12) hours += 12;
  if (normalizedMeridian === "am" && hours === 12) hours = 0;

  return { hours, minutes };
};

const formatWithdrawalTime = (timeString) => {
  const parsed = parseWithdrawalTime(timeString);
  if (!parsed) return timeString?.trim() || "";

  const meridian = parsed.hours >= 12 ? "PM" : "AM";
  const hours = parsed.hours % 12 || 12;
  const minutes = String(parsed.minutes).padStart(2, "0");
  return `${hours}:${minutes} ${meridian}`;
};

export const getWithdrawalWindowLabel = (openTime, closeTime) => {
  if (!openTime || !closeTime) return "";
  return `${formatWithdrawalTime(openTime)} to ${formatWithdrawalTime(closeTime)}`;
};

export const getWithdrawalDisabledMessage = (openTime, closeTime) => {
  const windowLabel = getWithdrawalWindowLabel(openTime, closeTime);
  if (!windowLabel) return "Withdrawals are temporarily disabled.";
  return `Withdrawals are temporarily disabled. Withdrawal timing: ${windowLabel}.`;
};
